import React from "react";
import "./What_Expect_Next.css";

function What_Expect_Next() {
  return (
    <>
      <section className="What_Expect_Next">
        <div className="heading_text_holder">
          <h4>What To Expect Next</h4>
        </div>
        <div className="text_holder">
          <p>
            As your order progresses, we'll keep you informed every step of the
            way.
          </p>

          <p>
            {" "}
            Once your order is ready for pickup or dispatched, we will promptly
            notify you with tracking information.
          </p>
        </div>
      </section>
    </>
  );
}

export default What_Expect_Next;
